module.exports = __webpack_public_path__ + "media/images/category_icons/articles-948465990276f5287b68bfb99b853cd0.svg";